<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="col-xs-12 text-left form-group">
          <div class="btn btn-default btn-table-title" @click="crElement()">新增{{tabName}}</div>
          <div class="btn btn-default btn-table-title" @click="goToEditElement()">編輯{{tabName}}</div>
          <div
            v-if="tab === 2"
            class="btn btn-default btn-table-title"
            :class="{ 'disabled': process }"
            data-toggle="modal"
            data-target="#copy-option-modal"
          >
            複製配料
          </div>
          <div v-if="!deletestatus" class="btn btn-default btn-table-title" @click="deletestatus = true">批次刪除</div>
          <button v-if="deletestatus" class="btn btn-danger" data-toggle="modal" data-target="#delModal" @click="deleteProducts">刪除選中</button>
          <div v-if="deletestatus" class="btn btn-default btn-table-title" @click="deletestatus = false">取消</div>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchKey">
            <option value="name">名稱</option>
            <option value="vendor_custom_id">商品料號</option>
            <option value="remark">備註</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input class="form-control" type="text" v-model="searchInput">
            <span class="input-group-addon c-pointer" @click="getList"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th v-if="deletestatus" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">
              <input type="checkbox" v-model="selectall" @input="selectItemAll()"/>
            </th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="width: 30%">名稱 (ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="width: 30%">商品料號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="width: 30%">備註</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="width: 20%"></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(bind, index) in bindList">
            <!--批次刪除-->
            <td v-if="deletestatus">
                <input type="checkbox" v-model="bind.selectItem"/>
            </td>
            <!-- cloumn 0 -->
            <td class="sorting_1">{{index + 1}}</td>
            <!-- column 1-->
            <td>
              <div v-if="!bind.edit_state">{{bind.name}} ({{bind.item_id}})</div>
              <input v-else class="form-control" v-model="bind.edit_name" maxlength="70">
            </td>
            <td>
              <div v-if="!bind.edit_state">{{bind.vendor_custom_id}}</div>
              <input v-else class="form-control" v-model="bind.edit_vendor_custom_id">
            </td>
            <td>
              <div v-if="!bind.edit_state">{{bind.remark}}</div>
              <input v-else class="form-control" v-model="bind.remark" maxlength="45">
            </td>
            <td>
              <button class="btn btn-default" v-if="!bind.edit_state" @click="bind.edit_state = !bind.edit_state"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              <button class="btn btn-success" v-if="bind.edit_state" @click="upElement(bind)"><i class="fa fa-check" aria-hidden="true"></i></button>
              <button class="btn btn-default" v-if="bind.edit_state" @click="bind.edit_state = !bind.edit_state"><i class="fa fa-times" aria-hidden="true"></i></button>
            </td>
            <td>
              <button class="btn btn-danger" data-toggle="modal" data-target="#delModal" @click="delModalOpen(bind)"><i class="fa fa-trash" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 text-center">
        <ul class="pagination">
          <li class="paginate_button" v-if="pageAmount > 1 && pageGroup !== 1" @click="pageGroup = pageGroup - 1">
            <a class="c-pointer"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
            <a class="c-pointer">{{index}}</a>
          </li>
          <li class="paginate_button" v-if="pageAmount > 1 && pageAmount / groupAmount > pageGroup" @click="pageGroup = pageGroup + 1">
            <a class="c-pointer"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 複製配料 -->
    <nd-modal
      class="text-left"
      :option="copyOptionsConf"
      @trigger="trigger"
    >
      <template v-slot:body>
        <nd-copy-options-store
          :brandId="brandId"
          :getDataH="getDataH"
          :storeId="storeId"
          @update:choose="updateChoose"
        />
      </template>
    </nd-modal>

    <nd-modal
      class="text-left"
      :option="copyOptionsConfChecked"
      @trigger="trigger"
    >
      <template v-slot:body>
        確定複製並套用至門市？
      </template>
    </nd-modal>
    <!-- End 複製配料 -->

    <nd-modal
      class="text-left"
      :option="delOption"
      @trigger="trigger"
    />
  </div>
</template>

<script>
// import $ from 'jquery'
import { mapGetters } from 'vuex'

import matcherModal from '../../../elements/Modal.vue'
import NdCopyOptionsStore from '@/components/elements/nd-copy-options-store.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default{
  name: 'NdBindingTable',
  props: {
    bindList: Array,
    bindMeta: Object,
    getBindingList: Function,
    input: String,
    isDeleteStatus: Boolean,
    sPage: Number,
    selectAll: Boolean,
    skey: String,
    tab: Number
  },
  extends: NdExtendHandleMenu,
  components: {
    'nd-copy-options-store': NdCopyOptionsStore,
    'nd-modal': matcherModal
  },
  data () {
    return {
      brandId: 0,
      copyOptionsChoose: [],
      copyOptionsConf: {
        id: 'copy-option-modal',
        title: '複製配料庫',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'copyOptions'
          }
        ]
      },
      copyOptionsConfChecked: {
        id: 'copy-option-modal-checked',
        title: '提醒',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'copyOptionsChecked'
          }
        ]
      },
      count: 20,
      curId: 0,
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '刪除綁定，此處刪除等同刪除該項目所有關聯！<br>刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBind'
          }
        ]
      },
      deletestatus: false,
      groupAmount: 10,
      pageGroup: 1,
      searchInput: '',
      searchKey: 'name',
      selectActive: 99,
      selectall: false,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      storeId: 0,
      tableIndex: 1,
      total: 0,
      process: false
    }
  },
  methods: {
    selectItemAll () {
      this.selectall = !this.selectall
      this.bindList.forEach((item) => {
        item['selectItem'] = this.selectall
      })
    },
    deleteProducts () {
      this.delOption.btns[1].event = 'delBinds'
      this.delOption.title = '刪除綁定'
    },
    copyOptions () {
      console.log('copyOptions')

      if (!this.copyOptionsChoose.length) {
        window.$('#copy-option-modal').modal('hide')
      } else {
        window.$('#copy-option-modal-checked').modal('show')
      }
    },
    copyOptionsChecked () {
      console.log('copyOptionsChecked')
      const url = `${this.base}${this.id}/menu/copyToStore`
      const data = {
        store_list: this.copyOptionsChoose
      }

      if (!this.copyOptionsChoose.length) return

      try {
        if (this.process) return
        this.process = true
        this.getDataH('post', url, data, (res) => {
          if (res.data.status === 200) {
            this.$notify({
              title: '提醒',
              text: '已複製成功！',
              duration: 1000,
              type: 'success',
              width: 400
            })
            this.process = false
          }
        })
      } catch (e) {
        console.error(e)
        this.process = false
      }
    },
    getList () {
      this.tableIndex = 1
      this.getBindingList(1, this.searchKey, this.searchInput)
    },
    delModalOpen (bind) {
      console.log(bind)
      this.delOption.title = '刪除' + bind.name + '綁定'
      this.delOption.btns[1].event = 'delBind'
      this.curId = bind.item_id
    },
    trigger (event) {
      if (event === 'copyOptions') {
        this.copyOptions()
      } else if (event === 'copyOptionsChecked') {
        this.copyOptionsChecked()
      } else if (event === 'delBind') {
        this.delBind()
      } else if (event === 'delBinds') {
        this.delBind('batch')
      }
    },
    delBind (type) {
      let deleteQuery = ''
      if (type === 'batch') {
        const deleteItems = this.bindList.filter((i) => i.selectItem).map((i) => i.item_id)
        if (deleteItems.length === this.bindList.length && this.tableIndex !== 1) {
          this.tableIndex = this.tableIndex - 1
        }
        deleteQuery = deleteItems.toString()
      } else {
        deleteQuery = this.curId
      }
      const url = this.base + this.id + '/itemBinding?item_id=' + deleteQuery + '&type=' + this.tab
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.curId = 0
          this.$notify({
            title: '提醒',
            text: '已成功刪除',
            duration: 3000,
            type: 'success',
            width: 400
          })
          if (this.searchInput && this.searchKey) {
            this.getBindingList(this.tableIndex, this.searchKey, this.searchInput)
            this.selectall = false
            this.deletestatus = false
          } else {
            this.getBindingList(this.tableIndex)
            this.selectall = false
            this.deletestatus = false
          }
        }
      })
    },
    goToEditElement () {
      let to = {
        name: '',
        params: {
          brand_id: this.$route.params.brand_id
        }
      }
      switch (this.tab) {
        // 配料
        case 2:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuOption'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'upOption'
          }
          break
        // 配料群組
        case 20:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuAdjust'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'upAdjust'
          }
          break
        // 商品分類
        case 10:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuCategory'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'upCategory'
          }
          break
        // 商品
        case 1:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuProduct'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'upProduct'
          }
          break
        // 品項選擇區
        case 11:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuBlock'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'upBlock'
          }
          break
        // 套餐
        case 3:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuPackage'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'upPackage'
          }
          break
      }
      this.$router.push({
        name: to.name,
        params: to.params
      })
    },
    crElement () {
      let to = {
        name: '',
        params: {
          brand_id: this.$route.params.brand_id
        }
      }
      switch (this.tab) {
        case 2:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuOptionCreate'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'crOptions'
          }
          break
        case 20:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuAdjustCreate'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'crAdjusts'
          }
          break
        case 10:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuCategoryCreate'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'crCategories'
          }
          break
        case 1:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuProductCreate'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'crProducts'
          }
          break
        case 11:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuBlockCreate'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'crBlocks'
          }
          break
        case 3:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuPackageCreate'
            to.params.store_id = this.$route.params.store_id
          } else {
            to.name = 'crPackages'
          }
          break
      }
      this.$router.push({
        name: to.name,
        params: to.params
      })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getBindingList(index, this.searchKey, this.searchInput)
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    upElement (bind) {
      const url = this.base + this.id + '/itemBinding/' + bind.item_id
      const data = {
        name: bind.edit_name,
        remark: bind.remark,
        type: this.tab,
        vendor_custom_id: bind.edit_vendor_custom_id
      }
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          bind.edit_state = !bind.edit_state
          bind.vendor_custom_id = bind.edit_vendor_custom_id
          bind.remark = bind.remark
          bind.name = bind.edit_name
          this.$notify({
            title: '提醒',
            text: '已更新' + bind.name,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    updateChoose (val) {
      console.log('updateChoose', val)
      this.copyOptionsChoose = val
    },
    setEditDefault () {
      for (var i = 0; i < this.bindList.length; i++) {
        this.$set(this.bindList[i], 'edit_name', this.bindList[i].name)
        this.$set(this.bindList[i], 'edit_vendor_custom_id', this.bindList[i].vendor_custom_id)
        this.$set(this.bindList[i], 'remark', this.bindList[i].remark)
        this.$set(this.bindList[i], 'edit_state', false)
      }
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    selectActive () {
      this.tableIndex = 1
      this.searchInput = ''
    },
    tab () {
      this.tableIndex = 1
      this.searchInput = ''
      this.searchKey = 'name'
      this.selectall = false
      this.deletestatus = false
      this.setEditDefault()
    },
    bindList () {
      this.setEditDefault()
    },
    bindMeta () {
      this.total = this.bindMeta.total
      this.count = this.bindMeta.size
    },
    key () {
      this.searchKey = this.key
    },
    input () {
      this.searchInput = this.input
    },
    tableIndex () {
      this.selectall = false
    }
  },
  created () {
    if (this.input !== '') {
      this.searchInput = this.input
    }
    if (this.skey !== '') {
      this.searchKey = this.skey
    }
    if (this.sPage !== 1) {
      this.tableIndex = Number(this.sPage)
    }
  },
  mounted () {
    console.log('mounted')
    if (this.getRoleType === 10) {
      this.storeId = Number(this.$route.params.brand_id)
    } else {
      this.brandId = Number(this.$route.params.brand_id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BindingTable.vue?53966fa3